<script setup lang="ts">
const props = withDefaults(defineProps<{
  onConfirm?: () => void
  onCancel?: () => void
}>(), {
  onCancel: () => { },
  onConfirm: () => { },
})

const modal = useModal()

const onConfirm = () => {
  props.onConfirm()
  modal.close()
}

const onCancel = () => {
  props.onCancel()
  modal.close()
}
</script>

<template>
  <UiAlertDialog
    :open="true"
    @hide="onCancel"
  >
    <UiAlertDialogContent
      :title="$t('Activate tablet scoring mode')"
      :description="$t('Tablet mode will log you out of the current session and start tournament tablet mode on this device.') + ' ' + $t('To disable tablet mode, tap the dartsspace logo on the top left 5 times and tap exit tablet mode.')"
      @cancel="onCancel"
      @confirm="onConfirm"
    />
  </UiAlertDialog>
</template>
